import React, { useRef } from 'react';
import './InlinePushup.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';


export interface IInlinePushupProps{
    messages?: string[];
} 

const InlinePushup = (
    props: IInlinePushupProps,
): JSX.Element => {
    const ref = useRef();
    // Handles case when page initializes and messages array is initialized to all undefined
    if (props.messages?.every(message => message === undefined) || props.messages?.length === 0) {
        return null;
    }

    return (
        <div className='InlinePushup'>
            {props.messages?.length > 0 && (
                <ul ref={ref} className='ml-0 mb-0'>
                    {props.messages.map((item, index) => {
                        return (
                            <li key={index} className='InlinePushup__listItem'>
                                {transformHTMLParserLinks(item)}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default InlinePushup;